// extracted by mini-css-extract-plugin
export var fullWidthButton = "_hx-0";